import { IDropdownOption } from '@fluentui/react';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { parseInputNumber } from '../../../../NumberField';
import { actions, createFormSelector } from '../../../slice';
import { Payment } from '../../../slice/newFormReducers';

export const useColumnSelector = <T extends keyof Payment>(
  uuid: string,
  key: T
): Payment[T] | undefined => {
  const selector = useMemo(
    () =>
      createFormSelector(
        (state) => state.payments,
        (payments) => payments?.[uuid]?.[key]
      ),
    [uuid, key]
  );

  return useSelector(selector);
};

export const useColumnOnChangeFn = (
  uuid: string,
  key: keyof Payment,
  toNumber?: boolean
) => {
  return useMemo(
    () => (_: any, newValue?: string | number | boolean | IDropdownOption) => {
      if (typeof newValue === "object") newValue = newValue.key;

      if (toNumber && typeof newValue === "string")
        newValue = parseInputNumber(newValue);

      actions.setFormPaymentVariable([uuid, key, newValue]);
    },
    [uuid, key]
  );
};
